import Helper from '@ember/component/helper';
import humanizeDuration from 'humanize-duration';

export function humanizeDurationHelper([value]) {
  let duration = value * 60 * 1000;
  return humanizeDuration(duration);
}

export default Helper.helper(humanizeDurationHelper);
